import { CampaignFrequency } from './Campaigns';
import {
  RmaLgmCommodityCode,
  RmaLgmCommodityCodes,
} from './lgm/LgmCommodities';
import {
  RmaLrpCommodityCode,
  RmaLrpCommodityCodes,
} from './lrp/LrpCommodities';

export const InsuranceType = {
  YIELD: 0,
  REVENUE: 1,
  REVENUE_HPE: 2,
} as const;

export type InsuranceType = (typeof InsuranceType)[keyof typeof InsuranceType];

export const ApplicationTypes = {
  INDIVIDUAL: 'individual',
  BUSINESS: 'business',
} as const;

export type ApplicationTypes =
  (typeof ApplicationTypes)[keyof typeof ApplicationTypes];

export const ApplicationOwnerTypeDescriptions = {
  Farmer: 'Farmer',
  Landlord: 'Landlord',
} as const;

export type ApplicationOwnerTypeDescriptions =
  (typeof ApplicationOwnerTypeDescriptions)[keyof typeof ApplicationOwnerTypeDescriptions];

export const ProgramIndicatorDescriptions = {
  BeginningFarmerRancher: 'Beginning Farmer/Rancher',
  VeteranFarmerRancher: 'Veteran Farmer/Rancher',
  Neither: 'Neither',
} as const;

export type ProgramIndicatorDescriptions =
  (typeof ProgramIndicatorDescriptions)[keyof typeof ProgramIndicatorDescriptions];

export const SupportedRmaCommodityCodes = [
  RmaLrpCommodityCodes.FEEDER_CATTLE,
  RmaLrpCommodityCodes.FED_CATTLE,
  RmaLrpCommodityCodes.SWINE,
  RmaLgmCommodityCodes.CATTLE,
];

// TODO: Get rid of one of these enums
// lowercase for URL param purposes
export const LivestockInsuranceTypes = {
  LRP: 'lrp',
  LGM: 'lgm',
} as const;

export type LivestockInsuranceTypes =
  (typeof LivestockInsuranceTypes)[keyof typeof LivestockInsuranceTypes];

export const InsureIQPolicyTypes = {
  LRP: 'LRP',
  LGM: 'LGM',
} as const;

export type InsureIQPolicyTypes =
  (typeof InsureIQPolicyTypes)[keyof typeof InsureIQPolicyTypes];

// TODO: Clean up the need for this conversion function
export const convertToCapitalizedLivestockInsTypes = (
  type: InsureIQPolicyTypes | LivestockInsuranceTypes
) => {
  if (
    type === InsureIQPolicyTypes.LRP ||
    type === LivestockInsuranceTypes.LRP
  ) {
    return InsureIQPolicyTypes.LRP;
  } else {
    return InsureIQPolicyTypes.LGM;
  }
};

export const LivestockInsuranceTypeLabels = {
  LRP: 'Livestock Risk Protection (LRP)',
  LGM: 'Livestock Gross Margin (LGM)',
} as const;

export type LivestockInsuranceTypeLabels =
  (typeof LivestockInsuranceTypeLabels)[keyof typeof LivestockInsuranceTypeLabels];

// lowercase for URL param purposes
export const LivestockInsuranceUnits = {
  CWT: 'cwt',
  HEAD: 'head',
  TOTAL: 'total',
} as const;

export type LivestockInsuranceUnits =
  (typeof LivestockInsuranceUnits)[keyof typeof LivestockInsuranceUnits];

export const LivestockInsuranceOptions = [
  {
    value: LivestockInsuranceTypes.LRP,
    label: LivestockInsuranceTypeLabels.LRP,
  },
  {
    value: LivestockInsuranceTypes.LGM,
    label: LivestockInsuranceTypeLabels.LGM,
  },
];

export const LgmUnits = [
  {
    value: LivestockInsuranceUnits.HEAD,
    label: 'Head',
  },
  {
    value: LivestockInsuranceUnits.TOTAL,
    label: 'Total',
  },
];

export const LrpUnits = [
  {
    value: LivestockInsuranceUnits.CWT,
    label: 'CWT',
  },
  ...LgmUnits,
];

export const LivestockUnitsOptionsByType = {
  [LivestockInsuranceTypes.LGM]: LgmUnits,
  [LivestockInsuranceTypes.LRP]: LrpUnits,
};

export const CampaignFrequenciesByType = {
  [LivestockInsuranceTypes.LGM]: [
    CampaignFrequency.WEEKLY,
    CampaignFrequency.MONTHLY,
  ],
  [LivestockInsuranceTypes.LRP]: [
    CampaignFrequency.DAILY,
    CampaignFrequency.WEEKLY,
    CampaignFrequency.MONTHLY,
  ],
};

export function isValidRmaCommodityCode(value: string): boolean {
  return (
    Object.values(RmaLrpCommodityCodes).includes(
      value as RmaLrpCommodityCode
    ) ||
    Object.values(RmaLgmCommodityCodes).includes(value as RmaLgmCommodityCode)
  );
}
